import { createContext } from 'react';

import type { RootProps } from './rootProp';

export const ContainerContext = createContext<RootProps>({} as RootProps);

